module.exports = __webpack_public_path__ + "88dd918ea5e50780cc7b01f41358f757.pdf";